import api from "./../utils/api";

const extractStatistics = (response) => response?.data?.statistics || {};

export const getDashboardData = async () => {
    try {
        const response = await api.get(
            `/analytic/dashboard`,
            {
                withCredentials: true,
                timeout: 60000,
            }
        );

        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getDashboardCoreData = async () => {
    const response = await api.get(`/analytic/dashboard/core`, {
        withCredentials: true,
        timeout: 30000,
    });

    return extractStatistics(response.data);
};

export const getDashboardChartsData = async () => {
    const response = await api.get(`/analytic/dashboard/charts`, {
        withCredentials: true,
        timeout: 45000,
    });

    return extractStatistics(response.data);
};

export const getDashboardTablesData = async () => {
    const response = await api.get(`/analytic/dashboard/tables`, {
        withCredentials: true,
        timeout: 45000,
    });

    return extractStatistics(response.data);
};
